import { render, staticRenderFns } from "./card-strategy-pnl.component.vue?vue&type=template&id=561e7700&scoped=true"
import script from "./card-strategy-pnl.component.vue?vue&type=script&lang=js"
export * from "./card-strategy-pnl.component.vue?vue&type=script&lang=js"
import style0 from "./card-strategy-pnl.component.vue?vue&type=style&index=0&id=561e7700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e7700",
  null
  
)

export default component.exports